import _ from 'lodash';
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as brands_actions from 'data/brands/actions';
import * as categories_actions from 'data/categories/actions';
import * as mediagroups_actions from 'data/mediagroups/actions';

import Page from 'components/Page/Page';
import PageSection from 'components/Page/PageSection';
import PageBlock from 'components/Page/PageBlock';
import * as os from 'osutil';


import BrandCard from 'components/Brand/BrandCard';

import PageHeader from 'components/Page/PageHeader';
import PageHeaderImage from 'components/Page/PageHeaderImage';

class Mediagroup extends Component {
  state = { tab: "a"};
  static contextTypes = {
    router: PropTypes.object
  };

  tabs = [
    { label: "Översikt", key: "summary" },
    { label: "Statistik", key: "statistics" },
    { label: "Medier", key: "brands" },
  ];

  handleCancel(id) {
    this.context.router.history.push("/medier");
  }

  handleChange = (e) => {
    this.setState({...this.state, tab:e});
  }

  componentWillMount() {
    this.props.actions.fetchMediagroup(this.props.params.id);
    this.props.actions.fetchMediagroups();
    this.props.actions.fetchCategories();
    this.props.actions.fetchBrands();
  }

  renderBrands() {
    return _.map(this.props.brands, (brand, key) => {
      return <BrandCard key={key} id={key} brand={brand} />
    });
  }

  render() {

    if (!this.props.mediagroup)
    {
      return null;
    }
    return (
      <Page ready={!this.props.pending} className="Mediagroup">
        <PageHeaderImage url={this.props.mediagroup.bgimageUrl}/>

        <PageHeader tabs={this.tabs} title={this.props.mediagroup.name} bg={this.props.mediagroup.bgimageUrl} logo={this.props.mediagroup.logoUrl}>
        </PageHeader>

        <PageSection>

          <PageBlock right={true} label="Medier">
            <div className="Mediagroup_grid" >
              {this.renderBrands()}
            </div>
          </PageBlock>

          <PageBlock label="Beskrivning">
            <p dangerouslySetInnerHTML={{__html: this.props.mediagroup.description}} />
          </PageBlock>

        </PageSection>
      </Page>
    );
  }
}

function mapStateToProps(state, ownProps) {

  var mediagroup = state.mediagroups.details.data

  if (!mediagroup)
  {
    return {};
  }

  var brands = os.filter_by_key_value(state.brands.list.data, "mediagroupid", ownProps.params.id);
  
  return {
    brands: brands,
    mediagroup: mediagroup,
    mediagroups: state.mediagroups.list.data,
    pending: state.mediagroups.list.pending
  };
}

const mapDispatch = (dispatch) => {
    return {
        actions: bindActionCreators({...brands_actions , ...categories_actions , ...mediagroups_actions}, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatch)(Mediagroup)

  



// WEBPACK FOOTER //
// ./src/pages/mediagroups/Mediagroup.jsx